import { SideBarMenuItemGroup } from 'src/app/models/side-bar-menu-item-group';
import { UserAccessLevelGroupName } from 'src/app/enums/user-access-level-group-name.enum';
import { AppRouteEnum } from 'src/app/enums/app-route.enum';

export const adminMenuItemsGroup: SideBarMenuItemGroup[] = [
  {
    label: 'Admin',
    menuItems: [
      {
        icon: 'sheet',
        routerLink: [AppRouteEnum.PracticeAdmin, 'lab-script'],
        name: 'Lab Script',
        accessLevelGroup: UserAccessLevelGroupName.AdminAccessLevelGroup
      }
    ]
  }
];
